import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import StudentAccountMenu from './StudentAccountMenu';

// `showStudentMenu` adds the same account menu (Profile, Logout) as the student dashboard's header.
function DashboardHeader({ title, backTo = '/dashboard', showStudentMenu = false }) {
  return (
    <header className="w-full shrink-0 h-20 bg-[#0b4a71] border-b border-gray-200 px-4 flex items-center gap-3">
      {backTo && (
        <Link to={backTo} aria-label="Back to dashboard" className="text-white/80 hover:text-white">
          <ArrowLeftIcon className="h-6 w-6" />
        </Link>
      )}
      {title && <h1 className="flex-1 min-w-0 truncate text-xl font-semibold text-white">{title}</h1>}
      {showStudentMenu && <StudentAccountMenu />}
    </header>
  );
}

export default DashboardHeader;
